// export default {
//   0: 'Work',
//   1: 'Home'
// }

export default {
  Work: 0,
  Home: 1
}
